// extracted by mini-css-extract-plugin
export var active = "_ia-2";
export var recordingDot = "_ia-1";
export var recordingIndicator = "_ia-0";